import React from 'react';
import "./styles.css"

const BlueButton = ({
                        disabled,
                        children,
                        onClick,
                        width = '100%',
                        height = '50px',
                        type = 'submit',
                        variant = 'default',
                        styles = {}
                    }) => {


    let classes = 'blue-button';

    if(variant === 'ghost') {
        classes += ' blue-button-ghost';
    }

    if(variant === 'outline') {
        classes += ' blue-button-outline';
    }

    return (
        <button
            disabled={disabled}
            type={type}
            className={classes}
            style={{
                width,
                height,
                ...styles
            }}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

export default BlueButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/BlueButton/index.jsx